import { isNil } from "lodash-es";
import React, { PureComponent, ReactNode } from "react";

import { ITestable, testProp } from "@/browser";

import { Label } from "../Label";
import { Flex } from "./../../../Flex";
import {
  IStyleFlexAlign,
  IStyleFlexDirection,
  IStyleFlexGrow,
  IStyleSize,
  IStyleWidth,
  TStyleWidth,
} from "./../../../Style";

interface Styles extends IStyleWidth, IStyleSize, IStyleFlexDirection, IStyleFlexGrow, IStyleFlexAlign {}

export interface IGroupProps extends Partial<Styles>, ITestable {
  label?: string;
  labelWidth?: TStyleWidth;
  fieldWidth?: TStyleWidth;
  required?: boolean;
  button?: ReactNode;
}

/**
 * @deprecated Will be removed in future releases. There will be no replacement of this component.
 * Please use own implementation of Group in forms
 */
export class Group extends PureComponent<IGroupProps> {
  static defaultProps = {
    direction: "row",
    size: "md",
    width: 12,
  } as IGroupProps;

  get isLabel() {
    return !isNil(this.props.label);
  }

  renderColumnDirection(children: Array<React.ReactElement<any>>) {
    const { direction, grow, label, size, required, width, align, button } = this.props;

    return (
      <Flex {...testProp(this.props)} align={align} direction={direction} grow={grow} width={width}>
        <Flex>
          {this.isLabel && (
            <Label {...testProp(this.props)} align="left" required={required} size={size} grow={1} flat>
              {label}
            </Label>
          )}
          {button}
        </Flex>
        <Flex direction="column" grow={1}>
          {children}
        </Flex>
      </Flex>
    );
  }

  renderRowDirection(children: Array<React.ReactElement<any>>) {
    const { direction, grow, label, size, required, width, labelWidth, fieldWidth, align = "center" } = this.props;

    return (
      <Flex {...testProp(this.props)} align={align} innerMargin="md" direction={direction} grow={grow} width={width}>
        {this.isLabel && (
          <Label
            {...testProp(this.props)}
            align="right"
            justify="flex-end"
            required={required}
            size={size}
            width={labelWidth || 2}>
            {label}
          </Label>
        )}
        <Flex direction="column" grow={1} width={fieldWidth}>
          {children}
        </Flex>
      </Flex>
    );
  }

  render() {
    const { children, direction, size } = this.props;

    // TODO(m.kania): check if this doesn't break anything
    const filteredChildren = React.Children.toArray(children).filter(c => React.isValidElement(c)) as Array<
      React.ReactElement<any>
    >;
    const clonedChildren = React.Children.map(filteredChildren, child => {
      const childSize = child.props.size || size;
      return React.cloneElement(child, { size: childSize });
    });

    if (direction === "column") {
      return this.renderColumnDirection(clonedChildren);
    }

    return this.renderRowDirection(clonedChildren);
  }
}
